import React, { useState } from 'react';
import MobileMenuItem from 'components/MobileMenu/MobileMenuItem';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import styled from 'styled-components/macro';
import { useDispatch } from 'react-redux';
import { openMobileMenuAction } from '../../containers/Ribbon/actions';
import { selectDrawerShelvesAction } from '../../containers/Configurator/actions/selection';

interface ArrowProps {
  text: string;
  className: string;
}

const Arrow = ({ text, className }: ArrowProps) => (
  <div className={className}>{text}</div>
);

const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });

export const Menu = (
  list: { name: string; key: string }[],
  selected: string | number | null,
) =>
  list.map((el: any) => {
    const { name, key } = el;

    return <MobileMenuItem text={name} key={key} selected={selected === key} />;
  });

interface Props {
  initialSelection: string | null;
  list: { name: string; key: string }[];
  cabinetEdit: any;
  panelOpen: boolean;
  multiShelfSelected?: boolean;
}

function MobileMenu({
  initialSelection,
  list,
  cabinetEdit,
  panelOpen,
  multiShelfSelected,
}: Props) {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState<string | number | null>(
    initialSelection,
  );

  const menu = Menu(list, selected);

  function onSelect(key: string | number | null) {
    if (selected === key) {
      setSelected(null);
      dispatch(openMobileMenuAction(false));
    } else {
      setSelected(key);
      dispatch(openMobileMenuAction(true));
    }
    if (key === 'drawers') {
      dispatch(selectDrawerShelvesAction());
    }
  }

  if (selected === 'action' && multiShelfSelected) {
    setSelected('height');
  }

  return (
    <div className="w-full">
      {/*{!panelOpen && <MobileAddShelf />}*/}
      <ScrollWrapper>
        <ScrollMenu
          data={menu}
          alignCenter={true}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          hideArrows={true}
          onSelect={onSelect}
          selected={selected !== null ? (selected as string) : undefined}
          scrollBy={0}
          wheel={false}
          transition={0}
        />
      </ScrollWrapper>
      {/*      <div className="flex flex-no-wrap overflow-x-auto">
        <MenuBtn>Width</MenuBtn>
        <MenuBtn className="border-b-2 border-black">Depth</MenuBtn>
        <MenuBtn>Corners</MenuBtn>
        <MenuBtn>Support</MenuBtn>
        <MenuBtn>Upper plate</MenuBtn>
        <MenuBtn>Range</MenuBtn>
      </div>*/}
      {selected && (
        <div>
          <StyledMobileItemContent className="mobile-item-content">
            {cabinetEdit(selected)}
          </StyledMobileItemContent>
        </div>
      )}
    </div>
  );
}

export default MobileMenu;

const ScrollWrapper = styled.div`
  margin: 0 1rem;
`;

const StyledMobileItemContent = styled.div`
  display: flex;
  min-height: 6rem;
  overflow-y: auto;
`;
